import { gql } from '@apollo/client';

export const GET_ENTITY_INFO = gql`
  query GetEntityInfo($entityName: String!) {
    getEntityInfo(entityName: $entityName) {
      id
      name
      fields {
        id
        name
        propertyPath
        relationName
      }
    }
  }
`;

export const GET_FILTER_SQL = gql`
  query Query($entityName: String!, $filterGroup: [FilterGroupInput!]) {
    getSQLQuery(entityName: $entityName, filterGroup: $filterGroup)
  }
`;
